
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetStaticProps } from "next"
import Head from "next/head"

import getCollectionCreators from "@/graphql/requests/getCollectionCreators"
import getFilters from "@/graphql/requests/getFilters"
import SEO from "@/meta/SEO"
import { GoogleAnalytics } from "@/services/GA4/GoogleAnalytics"
import Default from "@/templates/Default"
import Creator from "@/ts/Creator"
import FansiKind from "@/ts/enums/global/FansiKind"
import ProductType from "@/ts/enums/product/ProductType"
import FilterGroup from "@/ts/interfaces/global/FilterGroup"
import ProductsView from "@/views/products"
import useStaticProducts from "@/views/products/functions/useStaticProducts"

const PRODUCT_TYPE = ProductType.FansiCollection
function FansiCollectionsPage(props: FansiCollectionsPageProps) {
  const { staticFilters, staticCreators } = props

  const { filters, creators } = useStaticProducts({
    staticFilters,
    staticCreators,
    productType: PRODUCT_TYPE,
    withCollections: true,
  })

  if (!filters || !creators) return null

  return (
    <>
      <Head>
        <title>fansi Kolekcje | fansi.pl</title>
        <SEO description="Kupuj autorskie produkty z wyjątkowych, limitowanych kolekcji, stworzonych przez Twoich ulubionych Twórców, z którymi zadbasz o swój umysł, ciało i duszę, dom i bliskich." />
      </Head>
      <GoogleAnalytics />
      <ProductsView
        creators={creators}
        filters={filters}
        productType={PRODUCT_TYPE}
        fansiKind={FansiKind.FansiCollection}
      />
    </>
  )
}

FansiCollectionsPage.Layout = Default

 const _getStaticProps: GetStaticProps = async () => {
  const staticCreators = await getCollectionCreators()
  const staticFilters = await getFilters({
    withCollections: true,
    type: PRODUCT_TYPE,
  })
  return { props: { staticCreators, staticFilters }, revalidate: 1 }
}

interface FansiCollectionsPageProps {
  staticFilters: FilterGroup
  staticCreators: {
    creators: Creator[]
  }
}

export default FansiCollectionsPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/products/fansi-collections/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  